import React, { InputHTMLAttributes, useEffect, useRef } from 'react'
import classnames from 'classnames'
import './index.scss'
import { eventEmitter, eventEmitter_KEYS } from '@/utils/eventEmitter'

interface AppInputProps extends InputHTMLAttributes<any> {
  autoFocus?: boolean
}

const AppInput: React.FC<AppInputProps> = props => {
  const { className, autoFocus = false, ...rest } = props
  const inputRef = useRef(null)

  useEffect(() => {
    if (autoFocus) {
      ;(inputRef as any).current.focus()
    }
  }, [autoFocus])

  useEffect(() => {
    eventEmitter.addListener(eventEmitter_KEYS.searchInputBlur, () => {
      ;(inputRef as any).current.blur()
    })

    return () => {
      eventEmitter.removeAllListeners(eventEmitter_KEYS.searchInputBlur)
    }
  }, [])

  return (
    <div className={classnames('app-input-wrap', className)}>
      <div className="app-input-inner">
        <input ref={inputRef} {...rest} />
      </div>
    </div>
  )
}

export default AppInput
